/**
 * Gets the value for a key (e.g. foo)
 *
 * @param  {Object} data The date to look for the key in
 * @param  {String} key The nested key
 * @return {mixed}
 */
function getValue(data, key) {
  if ({}.hasOwnProperty.call(data, key)) {
    return data[key];
  }

  return false;
}

/**
 * Gets the value for a nested key (e.g. foo.bar)
 *
 * @param  {Object} data The date to look for the key in
 * @param  {String} key The nested key
 * @return {mixed}
 */
function getNestedValue(data, key) {
  const parts = key.split('.');

  if ({}.hasOwnProperty.call(data, parts[0])) {
    return getValue(data[parts[0]], parts[1]);
  }

  return false;
}

/**
 * Creates the html for an item
 *
 * @param  {Object} dataItem The data to create the item from
 * @param  {String} template The html template to create the item with
 * @return {String}
 */
export function buildHtml(data, template) {
  if (!data || !template) {
    return false;
  }

  return template.replace(/\${([a-zA-Z.]*)}/g, (m, key) => {
    const val = getValue(data, key);

    if (val) {
      return val;
    }

    if (!val && key.indexOf('.') !== -1) {
      return getNestedValue(data, key);
    }

    return '';
  });
}

/**
 * Gets a text template by it's ID
 *
 * @param  {Object} dataItem object containing nodeList and template name
 * @return {Node}
 */
export function getTemplate({ nodeList, templateName }) {
  let template = document.createElement('div');

  nodeList.forEach(node => {
    if (node.id === templateName) {
      template = node;
    }
  });

  return template;
}
